import React from 'react'
import Modal from '../../components/Modal'
import styles from './Withdraw.module.sass'
import { useTranslation } from 'react-i18next'

const SecurityAuthModal = ({
  visible,
  onClose,
  onSubmit,
  emailCode,
  onEmailCodeChange,
  loadingVerify
}) => {
  const canConfirm = emailCode.trim()
  const { t } = useTranslation()
  
  const handleSubmit = (e) => {
    e.preventDefault()

    if (!canConfirm) return

    onSubmit?.()
  }

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      isClosable
      outerClassName={styles.securityModalOuter}
    >
      <form className={styles.securityModal} onSubmit={handleSubmit}>
        <h2 className={styles.securityTitle}>Security authentication</h2>

        <div className={styles.securityField}>
          <div className={styles.securityInputWrap}>
            <input
              type="text"
              className={styles.securityInput}
              placeholder="E-mail Verification Code"
              value={emailCode}
              onChange={(e) => onEmailCodeChange(e.target.value)}
            />
            <button type="button" className={styles.sendCodeButton}>
              Click to send
            </button>
          </div>
          <p className={styles.securityHint}>
            Enter the code that your email `a.o****@exinitic.com` received
          </p>
        </div>
        <div className={styles.confirmActions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`${styles.confirmButton} ${canConfirm ? styles.confirmButtonActive : ''}`}
            disabled={!canConfirm &&  loadingVerify}
          >
            {loadingVerify ? t('Verifying...') : t('verify')}
          </button>
        </div>
      </form>
    </Modal>
  )
}

export default SecurityAuthModal
